import React from "react";

export const ProjectLabel = ({text}) => {
    return (
        <div className={'project-label'}>
            {text}
        </div>
    );
}